import { render, staticRenderFns } from "./errorHeader.vue?vue&type=template&id=cc8e2d4a&scoped=true"
import script from "./errorHeader.vue?vue&type=script&lang=js"
export * from "./errorHeader.vue?vue&type=script&lang=js"
import style0 from "./errorHeader.vue?vue&type=style&index=0&id=cc8e2d4a&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8e2d4a",
  null
  
)

export default component.exports